import React, { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/site";
import ImageUpload from "../ImageUpload";

const EMPTY = { company_name: "NOUROZI", company_tagline: "EBYGG & ANLEGG", logo_id: null, logo_url: "", facebook: "", instagram: "", google_business_url: "", google_verification: "", phone: "", email: "", area: "Halden og omegn" };

export default function GeneralSettings() {
  const [value, setValue] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    (async () => {
      try { const r = await api.get("/admin/settings/general"); setValue({ ...EMPTY, ...(r.data?.value || {}) }); }
      finally { setLoading(false); }
    })();
  }, []);
  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/settings/general", { value }); toast.success("Innstillinger lagret — last inn siden på nytt for å se logoen"); }
    catch { toast.error("Kunne ikke lagre"); }
    finally { setSaving(false); }
  };
  if (loading) return <div className="p-8 text-center bg-white border rounded-xl"><Loader2 className="animate-spin inline text-[#1B3626]"/></div>;

  const F = ({ k, label, placeholder }) => (
    <label className="block">
      <span className="text-[11px] uppercase tracking-wider text-[#555E68]">{label}</span>
      <input value={value[k] || ""} onChange={(e) => setValue({...value, [k]: e.target.value})} placeholder={placeholder} className="mt-1 w-full rounded-md border border-[#D5D0C7] px-3 py-2.5 text-sm" data-testid={`gen-${k}`} />
    </label>
  );

  return (
    <div className="space-y-5 mt-8 pt-8 border-t border-[#E2DDD5]">
      <div>
        <h2 className="font-display text-lg sm:text-xl font-bold">Generelle innstillinger</h2>
        <p className="text-sm text-[#555E68] mt-1">Endre logo, bedriftsnavn, sosiale medier og Google Business — vises umiddelbart på nettsiden.</p>
      </div>

      <div className="rounded-xl bg-white border border-[#E2DDD5] p-4 space-y-4">
        <h3 className="font-display font-bold text-sm">Bedriftsnavn og logo</h3>
        <div className="grid gap-3 sm:grid-cols-2">
          <F k="company_name" label="Bedriftsnavn (stort)" placeholder="NOUROZI" />
          <F k="company_tagline" label="Undertekst" placeholder="EBYGG & ANLEGG" />
        </div>
        <ImageUpload label="Logo (valgfritt — erstatter standard SVG)" mode="single" scope="brand" value={value.logo_id ? { id: value.logo_id } : (value.logo_url ? { url: value.logo_url } : null)} onChange={(v) => setValue({ ...value, logo_id: v?.id || null, logo_url: v?.id ? "" : (v?.url || "") })} />
        <label className="block">
          <span className="text-[11px] uppercase tracking-wider text-[#555E68]">... eller logo-URL</span>
          <input value={!value.logo_id ? (value.logo_url || "") : ""} onChange={(e) => setValue({...value, logo_url: e.target.value, logo_id: null})} placeholder="https://..." className="mt-1 w-full rounded-md border border-[#D5D0C7] px-3 py-2 text-xs" data-testid="gen-logo_url" />
        </label>
      </div>

      <div className="rounded-xl bg-white border border-[#E2DDD5] p-4 space-y-3">
        <h3 className="font-display font-bold text-sm">Kontakt & sosiale medier</h3>
        <div className="grid gap-3 sm:grid-cols-2">
          <F k="facebook" label="Facebook URL" placeholder="https://facebook.com/..." />
          <F k="instagram" label="Instagram URL" placeholder="https://instagram.com/..." />
          <F k="google_business_url" label="Google Business URL" placeholder="https://g.page/..." />
          <F k="google_verification" label="Google Search Console (content)" placeholder="abcd1234..." />
          <F k="phone" label="Telefon" placeholder="939 35 111" />
          <F k="email" label="E-post" placeholder="post@..." />
          <F k="area" label="Tjenesteområde" placeholder="Halden og omegn" />
        </div>
      </div>

      <div className="flex justify-end"><button onClick={save} disabled={saving} className="btn-primary" data-testid="gen-save">{saving ? <Loader2 size={14} className="animate-spin"/> : <Save size={14}/>} Lagre</button></div>
    </div>
  );
}
